import React, { useState, useContext } from "react";
import { AnswersContext } from "../../context/AnswersContext";
import parse from "html-react-parser";
import "../../sass/blocks/_contest-question.scss";

const ContestQuestion = (props) => {
    const {
        title,
        instruction,
        content,
        post_id,
        answers: answersDb,
        custom_answers,
        question_id,
        custom_answers_img,
    } = props.question;

    let initialState = {};

    const maxWeight = 3;

    const { index, prevQuestionHandler, nextQuestionHandler } = props;

    const { answers, setAnswers } = useContext(AnswersContext);

    answersDb.forEach((answer, item_index) => {
        initialState = {
            ...initialState,
            [`${post_id}-checkbox-${item_index}-${index}`]: {
                checked: false,
                answer: answer.answer,
                answer_id: answer.answer_id,
                question_id: question_id,
            },
        };
    });
    const [checkboxState, setCheckboxState] = useState(initialState);
    const [weights, setWeights] = useState([]);
    const [additionalAnswer, setAdditionalAnswer] = useState(false);
    const [checkboxLimit, setCheckboxLimit] = useState(3);
    const [inputValue, setInputValue] = useState("");

    const showAdditionalAnswer = () => {
        setAdditionalAnswer(true);
        setWeights([...weights, "additional-answer"]);
    };

    const hideAdditionalAnswer = () => {
        setAdditionalAnswer(false);
        if (weights.indexOf("additional-answer") !== -1) {
            const weightsCoppy = [...weights];
            weightsCoppy.splice(weights.indexOf("additional-answer"), 1);
            setWeights(weightsCoppy);
        }
    };

    const updateAnswers = (e) => {
        const currentAnswers = answers.filter(
            (answer) => answer.question_id !== question_id
        );

        weights.forEach((item, index) => {
            if (item !== "additional-answer") {
                const answerText = checkboxState[item].answer;
                const answer_id = checkboxState[item].answer_id;

                const newAnswer = {
                    page_id: post_id,
                    answer: answerText,
                    weight: maxWeight - index,
                    answer_id: answer_id,
                    question_id: question_id,
                };

                currentAnswers.push(newAnswer);
            }
        });

        if (additionalAnswer && inputValue.length > 0) {
            const newAnswer = {
                page_id: post_id,
                answer: inputValue,
                weight: maxWeight - weights.indexOf("additional-answer"),
                answer_id: 0,
                question_id: question_id,
            };

            currentAnswers.push(newAnswer);
        }

        setAnswers(currentAnswers);
        nextQuestionHandler();
    };

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    const handleInputCheck = (e) => {
        let list = [...weights];

        if (weights.length < checkboxLimit) {
            setCheckboxState({
                ...checkboxState,
                [e.target.name]: {
                    answer_id: checkboxState[e.target.name].answer_id,
                    checked: e.target.checked,
                    answer: checkboxState[e.target.name].answer,
                },
            });

            if (!list.includes(e.target.name) && e.target.checked) {
                list.push(e.target.name);
                setWeights(list);
            } else if (!e.target.checked) {
                let newList = list.filter((element) => {
                    return element != e.target.name;
                });
                setWeights(newList);
            }
        } else {
            let newList = list.filter((element) => {
                return element != e.target.name;
            });

            setWeights(newList);

            setCheckboxState({
                ...checkboxState,
                [e.target.name]: {
                    checked: false,
                    answer: checkboxState[e.target.name].answer,
                },
            });
        }
    };

    const showItemWeight = (targetElement) => {
        const itemArrayPos = weights.indexOf(targetElement);
        const itemWieght = maxWeight - itemArrayPos;
        return itemWieght;
    };

    return (
        <>
            <div className="contest-question__container-head contest-question__container-head--index">
                <h2
                    style={{ background: props.background }}
                    className="contest-question__heading contest-question__heading--index"
                >
                    {index * 1 + 1}
                    <b>/{props.questionsLength}</b>
                </h2>
            </div>

            <div className="contest-question__container-head">
                <h2 className="contest-question__heading">{title}</h2>
            </div>

            <div className="contest-question__desc">{content}</div>

            {instruction.length > 0 && (
                <p className="contest-question__instruction">
                    {parse(instruction)}
                </p>
            )}

            {answersDb.map((answer, item_index) => {
                return (
                    <div className="contest-input" key={item_index}>
                        <input
                            type="checkbox"
                            id={`input-${post_id}-checkbox-${item_index}-${index}`}
                            name={`${post_id}-checkbox-${item_index}-${index}`}
                            checked={
                                checkboxState[
                                    `${post_id}-checkbox-${item_index}-${index}`
                                ].checked
                            }
                            onChange={handleInputCheck}
                            className="contest-input__checkbox"
                        />
                        <label
                            className="contest-input__label"
                            htmlFor={`input-${post_id}-checkbox-${item_index}-${index}`}
                        >
                            <span className="contest-input__answer">
                                {answer.answer}
                            </span>
                            {answer.answer_img && (
                                <img
                                    className="contest-input__img"
                                    src={answer.answer_img}
                                />
                            )}
                            {checkboxState[
                                `${post_id}-checkbox-${item_index}-${index}`
                            ].checked && (
                                <span
                                    className={`contest-input__number ${
                                        answer.answer_img &&
                                        "contest-input__number--img-enabled"
                                    }`}
                                >
                                    {showItemWeight(
                                        `${post_id}-checkbox-${item_index}-${index}`
                                    )}
                                    &nbsp;pkt.
                                </span>
                            )}
                        </label>
                    </div>
                );
            })}

            {additionalAnswer && (
                <div className="input-group">
                    <input
                        className="input-group__input"
                        name="additional-answer"
                        autoComplete="off"
                        id="additional-answer"
                        onChange={handleInputChange}
                        placeholder="Twoja propozycja..."
                        value={inputValue}
                    ></input>
                    <label className="input-group__line"></label>
                    <span
                        className={`input-group__number ${
                            custom_answers_img &&
                            "contest-input__number--img-enabled"
                        }`}
                    >
                        {showItemWeight(`additional-answer`)}&nbsp;pkt.
                    </span>
                    {custom_answers_img && (
                        <img
                            className="contest-input__img"
                            src={custom_answers_img}
                        />
                    )}
                </div>
            )}

            {custom_answers && !additionalAnswer && weights.length < 3 && (
                <button
                    className="contest-question-flex__button contest-question-flex__button--add"
                    onClick={showAdditionalAnswer}
                    disabled={weights.length == 3 ? true : false}
                >
                    <svg
                        width="20"
                        height="20"
                        className="contest-question-flex__plus"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M10 0.00012207V20.0001M0 10.0001H20"
                            stroke="#404040"
                            stroke-width="3"
                        />
                    </svg>
                    Dodaj pozycję
                </button>
            )}

            {custom_answers && additionalAnswer && (
                <button
                    className="contest-question-flex__button contest-question-flex__button--add"
                    onClick={hideAdditionalAnswer}
                >
                    <svg
                        className="contest-question-flex__plus"
                        width="21"
                        height="4"
                        viewBox="0 0 21 4"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.5 2.00012H20.5"
                            stroke="#404040"
                            stroke-width="3"
                        />
                    </svg>
                    Usuń pozycję
                </button>
            )}

            <div className="contest-question-flex">
                {index > 0 && (
                    <button
                        className="contest-question-flex__button"
                        onClick={prevQuestionHandler}
                    >
                        Powrót
                    </button>
                )}
                <button
                    className="contest-question-flex__button contest-question-flex__button--next"
                    onClick={updateAnswers}
                >
                    Dalej
                    <svg
                        width="10"
                        height="24"
                        className="contest-question-flex__arrow"
                        viewBox="0 0 15 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M2 2.00012L12 12.0001L2 22.0001"
                            stroke="white"
                            stroke-width="3"
                        />
                    </svg>
                </button>
            </div>
        </>
    );
};

export default ContestQuestion;
